import styled from "styled-components";

export const StyledStartButton = styled.button`
  width: 100%;
  padding: 0.8rem 1rem;
  line-height: 1.2rem;
  margin: 0 0 1.25rem 0;
  border-radius: 1.25rem;
  border: none;
  color: #ddd;
  background: #333333cf;
  font-family: Pixel, Arial, Helvetica, sans-serif;
  outline: none;
  cursor: pointer;
  letter-spacing: 0.1rem;
`;
